import { render } from "./SectionWidgetByRoute.vue?vue&type=template&id=34a6f3c6"
import script from "./SectionWidgetByRoute.vue?vue&type=script&lang=js"
export * from "./SectionWidgetByRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__